
import { Component, Vue } from "vue-property-decorator";
import { namespace } from "vuex-class";
import { Table, InjectFunction } from "@common/src/utils/decorator";
import { emptyToLine, splitThousands } from "@common/src/utils/common";
import { formDownload } from "@common/src/utils/tools";
import dayjs from "dayjs";
import t from "@common/src/i18n/t";
import _ from "lodash-es";

const warehouse = namespace("warehouse");
const parts = namespace("parts");
const base = namespace("base");
const inventory = namespace("inventory");
const partsCategory = namespace("parts-category");
const common_warehouse = namespace("common_warehouse");

@InjectFunction("permit", "addCurrencySymbol")
@Component({})
@Table("loadListData")
export default class InventoryQuery extends Vue {
  @inventory.Action getInventoryRecord;
  @inventory.Action queryBusinessTypeList;
  @parts.Action updateStatus;
  @partsCategory.Action getCategoryList;
  @base.Action getDictionaryList;
  @warehouse.Action getWarehouseList;
  @common_warehouse.Action queryWarehouseShelfTree;
  searchForm = {
    partsName: "",
    partsCategoryCode: "",
    inventoryDetailType: "",
    warehouseCode: "",
    shelfCode: "",
    associatedNumber: "",
    businessTypeArr: []
  };
  splitThousands = splitThousands;
  dayjs = dayjs;
  emptyToLine = emptyToLine;
  sortForm: {};
  partsList: any[] = [];
  t = t;
  get searchList() {
    return [
      {
        label: "parts.name",
        type: "input",
        value: "",
        prop: "partsName"
      },

      {
        label: "parts.category",
        type: "cascader",
        prop: "partsCategoryCode",
        value: "",
        options: this.categoryList,
        props: {
          label: "categoryName",
          value: "categoryCode"
        }
      },
      {
        label: t("v210.associated-issue-receipt-doc-no"),
        type: "input",
        value: "",
        prop: "associatedNumber"
      },
      {
        label: t("v210.operation-time:"),
        type: "daterange",
        value: "",
        prop: "operatingTime"
      },
      {
        label: t("v216_6.outgoing-incoming-type"),
        type: "select",
        selectList: this.inventoryDetailTypeList,
        prop: "inventoryDetailType",
        value: "",
        changeMethod: this.handleChangeInventoryDetailType
      },
      {
        label: t("other.order-type"),
        type: "select",
        selectList: this.bussinessTypeList,
        prop: "businessTypeArr",
        value: [],
        multiple: true,
        disabled: this.bussinessTypeSelectDiasabled
      },
      {
        label: t("warehouse.warehouse"),
        type: "select",
        selectList: this.warehouseList,
        clearMethod: this.handleSearchWarehouseClear,
        changeMethod: this.handleSearchWarehouseChange,
        prop: "warehouseCode",
        value: ""
      },
      {
        label: t("v210.location"),
        type: "select",
        value: "",
        selectList: this.shelfList,
        prop: "shelfCode",
        disabled: this.shelfSelectDiasabled,
        noKeepOld: true
      }
    ];
  }
  categoryList: any[] = [];
  warehouseList: any = [];
  inventoryDetailTypeList: any = [];
  bussinessTypeList: any = [];
  bussinessTypeSelectDiasabled: boolean = true;
  created() {
    this.init();
  }
  async init() {
    this.loadListData();
    this.getDictionaryList("inventory_detail_type").then(data => {
      this.inventoryDetailTypeList = data;
    });
    this.queryWarehouseShelfTree({
      pageNum: 1,
      pageSize: 100
    }).then(data => {
      let list = this.$safeValue(data, "data.warehouseList", []);
      let warehouseList = [];
      list.forEach(item => {
        warehouseList.push({
          label: item.warehouseName,
          value: item.warehouseCode
        });
        if (!this.warehouseShelfMap[item.warehouseCode]) {
          this.warehouseShelfMap[item.warehouseCode] = item.shelfList;
        }
      });
      this.warehouseList = warehouseList;
    });
    const data = await this.getCategoryList();
    this.categoryList = this.addLeafFlag(this.$safeValue(data, "data", []));
  }
  sumData: any = [];
  @Table.LoadDataMethod()
  loadListData() {
    return this.getInventoryRecord({
      orderItems: this.mix_sortParams,
      ...this.searchForm,
      pageNum: this.mix_pageNum,
      pageSize: this.mix_pageSize,
      partsName: this.searchForm.partsName
    }).then(data => {
      this.partsList = this.$safeValue(data, "data.list", []);
      this.sumData = _.omit(data.data, ["list", "total"]);
      return data;
    });
  }
  addLeafFlag(list) {
    const f = function (list) {
      list.forEach(item => {
        if (!item.children || item.children.length < 1) {
          delete item.children;
        } else {
          f(item.children);
        }
      });
    };
    f(list);
    return list;
  }
  handleSearch(data, type) {
    if (type === "reset") {
      this.searchForm["businessTypeArr"] = [];
      this.bussinessTypeList = [];
      this.bussinessTypeSelectDiasabled = true;
    }
    this.mix_pageNum = 1;
    data.forEach(item => {
      if (item.prop) {
        if (item.prop === "operatingTime") {
          this.searchForm["operatingTimeBegin"] = item.value ? item.value[0] : "";
          this.searchForm["operatingTimeEnd"] = item.value ? item.value[1] : "";
        } else if (item.prop === "partsCategoryCode") {
          this.searchForm[item.prop] = item.value.slice(-1)[0];
        } else if (item.prop === "businessTypeArr") {
          this.searchForm["businessType"] = item.value ? item.value.join(",") : "";
        } else {
          this.searchForm[item.prop] = item.value;
        }
      }
    });
    this.loadListData();
  }
  handleLinkPartsDetail(row) {
    let { href } = this.$router.resolve({
      path: `/setting/parts-edit/${row.partsCode}`
    });
    window.open(href, "_blank");
  }
  warehouseShelfMap: any = {};
  shelfList: any = [];
  shelfSelectDiasabled: boolean = true;
  handleSearchWarehouseChange(val) {
    this.shelfSelectDiasabled = false;
    this.searchForm.shelfCode = "";
    this.shelfList = (this.warehouseShelfMap[val] || []).map(item => {
      item.label = item.shelfDesc;
      item.value = item.shelfCode;
      return item;
    });
  }
  handleSearchWarehouseClear() {
    this.shelfSelectDiasabled = true;
  }
  handleLinkInOutView(row) {
    if (row.associatedNumber.includes("CK")) {
      let { href } = this.$router.resolve({
        path: `/inventory/out-warehouse-view/${row.associatedNumber}`
      });
      window.open(href, "_blank");
    } else if (row.associatedNumber.includes("RK")) {
      let { href } = this.$router.resolve({
        path: `/inventory/in-warehouse-view/${row.associatedNumber}`
      });
      window.open(href, "_blank");
    }
  }
  handleChangeInventoryDetailType(val) {
    //清空之前的 出/入库类型 选项
    this.searchList.forEach(item => {
      if (item.prop) {
        if (item.prop === "businessTypeArr") {
          item.value = [];
        }
      }
    });
    this.bussinessTypeList = [];
    if (val) {
      let dataCode = val === "1" ? "outbound_type" : val === "2" ? "inbound_type" : "";
      this.bussinessTypeSelectDiasabled = false;
      this.queryBusinessTypeList({
        dataCode: dataCode
      }).then(data => {
        let list = this.$safeValue(data, "data.list", []);
        let bussinessTypeList = [];
        list.forEach(item => {
          bussinessTypeList.push({
            label: item.dataDesc,
            value: item.dataValue
          });
        });
        this.bussinessTypeList = bussinessTypeList;
        return data;
      });
    } else {
      this.bussinessTypeSelectDiasabled = true;
    }
  }
  handleExportData() {
    formDownload(`${window.API_URL}/inventory/queryInventoryDetail/download`, this.searchForm);
  }
}
